import React, { Component } from "react";
import { ArticleContentFrame } from "./styles";
import PropType from "prop-types";
import { commitMutation } from "react-relay";
import relayEnvironment from "../../../../RelayEnvironment";
import { GET_GM_SESSION } from "../../__tools/GreenMachinePage/SelectSlate/mutations/GetOrCreateGreenMachineSession";
import { COMMIT_PLAYER_CHANGES } from "../../__tools/GreenMachinePage/SelectPlayers/mutations/CommitPlayerSelectionChanges";

export default class ArticleContent extends Component {
  constructor(props) {
    super(props);

    this.addToGreenMachine = this.addToGreenMachine.bind(this);

    this.state = { errorMessage: undefined, lastPlayerId: "" };
  }

  componentDidMount() {
    document.body.addEventListener("click", this.props.onClick);
  }

  componentWillUnmount() {
    document.body.removeEventListener("click", this.props.onClick);
  }

  addToGreenMachine(e, playerId) {
    e.preventDefault();

    this.setState({ errorMessage: undefined });

    commitMutation(relayEnvironment, {
      mutation: GET_GM_SESSION,
      variables: {
        input: {
          slateId: this.props.articleSlateId,
        },
      },
      onCompleted: (content, errors) => {
        if (!errors) {
          commitMutation(relayEnvironment, {
            mutation: COMMIT_PLAYER_CHANGES,
            variables: {
              input: {
                greenMachineSessionId:
                  content.getOrCreateGreenMachineSessions
                    .greenMachineSessions[0].id,
                addPlayers: [playerId],
                removePlayers: [],
              },
            },
            onCompleted: (content, errors) => {
              if (!errors) {
                this.setState({
                  errorMessage: "Added to GM!",
                });
              } else {
                this.setState({ errorMessage: "Something went wrong." });
              }
            },
            onError: (error) => {
              this.setState({ errorMessage: "Something went wrong." });
            },
          });
        } else {
          this.setState({ errorMessage: "Something went wrong." });
        }
      },
      onError: (error) => {
        this.setState({ errorMessage: "Something went wrong." });
      },
    });
  }

  render() {
    if (!this.props.playerTooltipData && this.state.errorMessage) {
      this.setState({ errorMessage: undefined });
    }

    if (
      this.props.playerTooltipData &&
      this.props.playerTooltipData.id !== this.state.lastPlayerId
    ) {
      this.setState({
        errorMessage: undefined,
        lastPlayerId: this.props.playerTooltipData.id,
      });
    }

    return (
      <div style={{ position: "relative" }}>
        <ArticleContentFrame
          dangerouslySetInnerHTML={{ __html: this.props.articleContent }}
        />
        {this.props.playerTooltipData ? (
          <div
            id="article-player-tooltip"
            style={
              this.props.playerTooltipLoc
                ? {
                    top: this.props.playerTooltipLoc.top - 100 - 5,
                    left:
                      this.props.playerTooltipLoc.left +
                      this.props.playerTooltipLoc.width / 2 -
                      (this.props.playerTooltipLoc.width + 10) / 2,
                    width: this.props.playerTooltipLoc.width + 10,
                  }
                : {}
            }
          >
            {this.props.playerTooltipData.value}
            <br />
            <br />

            {this.state.errorMessage ? (
              <span>{this.state.errorMessage}</span>
            ) : (
              <button
                onClick={(e) =>
                  this.addToGreenMachine(e, this.props.playerTooltipData.id)
                }
              >
                Add to Green Machine
              </button>
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

ArticleContent.propTypes = {
  articleContent: PropType.string.isRequired,
};
